module.exports = __webpack_public_path__ + "static/media/100147.f9db15b9.png";